module.exports = __webpack_public_path__ + "img/slide12.ff60400a.png";